;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { atomWithStorage } from 'jotai/utils';
import createStorage from "@/lib/helpers/createStorage";
import { canAccessStorage } from '@/lib/helpers/is-storage-available';

const storage = createStorage<boolean>('localStorage')

let storedStationConfirmed: boolean;

if (canAccessStorage('localStorage')) {
  storedStationConfirmed = JSON.parse(window.localStorage.getItem('station-confirmed')!);

  // Defaulting to not confirmed
  if (!storedStationConfirmed) {
    window.localStorage.setItem('station-confirmed', JSON.stringify(false));
    storedStationConfirmed = false
  }
} else {
  storedStationConfirmed = false
}

export const stationConfirmedAtom = atomWithStorage<boolean>('station-confirmed', storedStationConfirmed, storage);
